import React, { ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
type FAppScrollToTopProps = {
	children: ReactNode;
};
const FAppScrollToTop = (props: FAppScrollToTopProps) => {
	const location = useLocation();
	useEffect(() => {
		window.scrollTo(0, 0);
	}, [location.pathname]);

	return <>{props.children}</>;
};

export default FAppScrollToTop;
